import { useState, useEffect } from "react";
import "../css/DoctorAppointmentCard.css";
import TopImg from "../assets/doctor_appointment_top_img.png";
import BottomImg from "../assets/doctor_appointment_bottom_img.png";
import { FiEdit } from "react-icons/fi";
import { RiDeleteBin6Fill } from "react-icons/ri";
import { LuDownload } from "react-icons/lu";
import { IoMdAdd } from "react-icons/io";
import api from "../api"; // centralized axios instance

const DoctorAppointmentCard = ({
  title,
  subscribedPrice,
  unsubscribedPrice,
  services: initialServices,
  tag,
  item, // must have id
  points,
  isEditable = false,
  onClose,
  onSave,
  onAddService,
  onDelete,
}) => {
  const [services, setServices] = useState(initialServices || points || []);
  const [showInput, setShowInput] = useState(false);
  const [newPoints, setNewPoints] = useState("");
  const [isEditingSubscribed, setIsEditingSubscribed] = useState(false);
  const [isEditingUnsubscribed, setIsEditingUnsubscribed] = useState(false);
  const [editedSubscribedPrice, setEditedSubscribedPrice] = useState(subscribedPrice);
  const [editedUnsubscribedPrice, setEditedUnsubscribedPrice] = useState(unsubscribedPrice);

  useEffect(() => {
    setServices(initialServices || points || []);
  }, [initialServices, points]);

  const renderBadge = () => {
    if (tag === "Popular") return <span className="doctor-appointment-popular-badge">Popular</span>;
    if (tag === "Great Deals") return <span className="doctor-appointment-greatDeals-badge">Great Deals</span>;
    if (tag === "Steal Deals") return <span className="doctor-appointment-stealDeals-badge">Steal Deals</span>;
    return null;
  };

  const handleServiceDelete = (indexToDelete) => {
    setServices(prev => prev.filter((_, i) => i !== indexToDelete));
  };

  const handleAddService = () => {
    if (newPoints.trim()) {
      setServices(prev => [...prev, newPoints.trim()]);
      setNewPoints("");
      setShowInput(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") handleAddService();
  };

  const handlePriceKeyDown = (e, type) => {
    if (e.key === "Enter") {
      if (type === "subscribed") setIsEditingSubscribed(false);
      if (type === "unsubscribed") setIsEditingUnsubscribed(false);
    }
  };

  const handleSaveClick = async () => {
    if (!item || !item.id) {
      console.error("Package ID is missing!", item);
      alert("Invalid package data.");
      return;
    }

    const patchData = {
      services: services.join(","), 
      subscribed_user_offer_amount: Number(editedSubscribedPrice),
      package_amount: Number(editedUnsubscribedPrice),
    };

    try {
      const response = await api.patch(`/doctor-appointment-packages/${item.id}/`, patchData);
      console.log("Package updated:", response.data);
      

      if (onSave) {
        onSave(services, editedSubscribedPrice, editedUnsubscribedPrice);
      }
    } catch (error) {
      console.error("Error updating package:", error);
      alert("Failed to update package. Please try again.");
    }
  };

  return (
    <div className={`doctor-appointment-package-card-wrapper ${isEditable ? "editable-modal" : ""}`}>
      {isEditable ? (
        <div className="doctor-appointment-package-card doctor-appointment-modal-card">
          <div className="doctor-appointment-card-top-image1-edit">
            <img src={TopImg} alt="top decoration" />
            {renderBadge()}
          </div>

          <div className="doctor-appointment-package-card-body">
            <div className="doctor-appointment-card-total-body">
              <div className="doctor-appointment-interbox1 doctor-appointment-points-underscore">
                <ul>
                  {services.map((point, index) => (
                    <li key={index} className="custom-list-item">
                      <span className="delete-icon" onClick={() => handleServiceDelete(index)}>−</span> {point}
                    </li>
                  ))}
                  {showInput && (
                    <li>
                      <input
                        type="text"
                        value={newPoints}
                        onChange={(e) => setNewPoints(e.target.value)}
                        onKeyDown={handleKeyPress}
                        autoFocus
                      />
                    </li>
                  )}
                </ul>
              </div>

              <div className="doctor-appointment-subscription-card-body">
                <div className="doctor-appointment-interbox">
                  <div className="doctor-appointment-card-edit-pricing">
                    <p>Subscribed User Price</p>
                    <h4 className="doctor-appointment-edit-sub-price">
                      {isEditingSubscribed ? (
                        <input
                          type="number"
                          value={editedSubscribedPrice}
                          onChange={(e) => setEditedSubscribedPrice(e.target.value)}
                          onKeyDown={(e) => handlePriceKeyDown(e, "subscribed")}
                          autoFocus
                          className="price-input"
                        />
                      ) : (
                        <>
                          ₹{editedSubscribedPrice}
                          <button
                            className="doctor-appointment-price-edit-btn"
                            onClick={() => setIsEditingSubscribed(true)}
                          >
                            <FiEdit size={18} color="#000" />
                          </button>
                        </>
                      )}
                    </h4>

                    <p>Unsubscribed User Price</p>
                    <h4 className="doctor-appointment-edit-sub-price">
                      {isEditingUnsubscribed ? (
                        <input
                          type="number"
                          value={editedUnsubscribedPrice}
                          onChange={(e) => setEditedUnsubscribedPrice(e.target.value)}
                          onKeyDown={(e) => handlePriceKeyDown(e, "unsubscribed")}
                          autoFocus
                          className="price-input"
                        />
                      ) : (
                        <>
                          ₹{editedUnsubscribedPrice}
                          <button
                            className="doctor-appointment-price-edit-btn"
                            onClick={() => setIsEditingUnsubscribed(true)}
                          >
                            <FiEdit size={18} color="#000" />
                          </button>
                        </>
                      )}
                    </h4>
                  </div>
                </div>
                <div className="doctor-appointment-card-actions">
                  <button className="add-package-doctor-appointment-edit-button" onClick={() => setShowInput(true)}>
                    <span className="add-package-doctor-appointment-save-icon">
                      <FiEdit size={20} color="#000" />
                    </span>
                    <span className="add-packages-save-text">Add Point</span>
                  </button>

                  {onDelete && (
                    <button className="add-package-doctor-appointment-delete-button" onClick={onDelete}>
                      <RiDeleteBin6Fill size={30} color="#FF3D00" />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="edit-btns">
            <button className="doctor-appointment-add-btn" onClick={() => setShowInput(true)}>
              <IoMdAdd className="add-package-icon" color="#EBA8BF" /> Add
            </button>
            <button className="doctor-appointment-save-btn" onClick={handleSaveClick}>
              <LuDownload className="add-package-icon" color="#EBA8BF" /> Save
            </button>
            <span className="close-btn" onClick={onClose}>Close</span>
          </div>

          <div className="doctor-appointment-card-bottom-image">
            <img src={BottomImg} alt="bottom decoration" />
          </div>
        </div>
      ) : (
        <div className="doctor-appointment-package-card">
          <div className="doctor-appointment-card-top-image1-edit">
            <img src={TopImg} alt="top decoration" />
            {renderBadge()}
          </div>

          <div className="doctor-appointment-package-card-body">
            <div className="doctor-appointment-card-total-body">
              <div className="doctor-appointment-interbox1">
                <div className="doctor-appointment-title">{title}</div>
                <ul className="doctor-appointment-points-list">
                  {points.map((point, index) => (
                    <li key={index}>{point}</li>
                  ))}
                </ul>
              </div>

              <div className="doctor-appointment-subscription-card-body">
                <div className="doctor-appointment-interbox">
                  <div className="doctor-appointment-card-pricing">
                    <p>
                      <strong className="add-package-doctor-appointment-text1">Subscribed User Price</strong>
                      <br />
                      <span className="doctor-appointment-price-subscribed">₹{subscribedPrice}</span>
                    </p>
                    <p>
                      <strong className="add-package-doctor-appointment-text1">Unsubscribed User Price</strong>
                      <br />
                      <span className="doctor-appointment-price-unsubscribed">₹{unsubscribedPrice}</span>
                    </p>
                  </div>
                </div>
                <div className="doctor-appointment-card-actions">
                  {onAddService && (
                    <button className="add-package-doctor-appointment-edit-button" onClick={onAddService}>
                      <span className="add-package-doctor-appointment-save-icon">
                        <FiEdit size={20} color="#000" />
                      </span>
                      <span className="add-packages-save-text">Edit</span>
                    </button>
                  )}

                  {onDelete && (
                    <button className="add-package-doctor-appointment-delete-button" onClick={onDelete}>
                      <RiDeleteBin6Fill size={32} color="#FF3D00" />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="doctor-appointment-card-bottom-image">
            <img src={BottomImg} alt="bottom decoration" />
          </div>
        </div>
      )}
    </div>
  );
};

export default DoctorAppointmentCard;
